<ng-dialog-header title="Load Train"></ng-dialog-header>
<mat-dialog-content>
  <div class="border p-2 m-2">
    <div class="row m-1">
      <div class="col">
        <h3>Permit Details</h3>
      </div>
    </div>
    <div class="row m-2">
      <div class="col-md-3">
        <strong>To Load Permit:</strong> {{ data?.permitNo }}
      </div>
      <div class="col-md-3">
        <strong>Receiver:</strong> {{ data?.receiver }}
      </div>
      <div class="col-md-3">
        <strong>#Cars Req:</strong> {{ data?.carsLoaded }}
      </div>
      <div class="col-md-3">
        <strong>Shipment Gross Wgt (lb):</strong> {{ data?.shipmentGrossWgt }}
      </div>
    </div>
    <div class="row m-2">
      <div class="col-md-3">
        <strong>Product Class:</strong> {{ data?.productClass }}
      </div>
      <div class="col-md-3">
        <strong>Scheduled Load:</strong> {{ data?.loadDt | date: 'MM-dd-yy' }}
      </div>
      <div class="col-md-3">
        <strong>#Cars WB:</strong> {{ data?.carsWaybilled }}
      </div>
      <div class="col-md-3">
        <strong>Standard Train Size:</strong> {{ data?.standardTrainSize }}
      </div>
    </div>
    <div class="row m-2">
      <div class="col-md-3">
        <strong>Req Car Type:</strong> {{ data?.carTypeCd }}
      </div>
    </div>
  </div>
  <form [formGroup]="form">
    <mat-radio-group formControlName="option">
      <div class="border p-2 m-2 row" style="height: 200px;" [ngClass]="form.controls.option.value === 'permit' ? 'border-primary' : ''">
        <div class="col-md-2 col-sm-4">
          <mat-radio-button value="permit"><strong>Select Empties by Permit</strong></mat-radio-button>
        </div>
        <div class="col-md-10 col-sm-8">
          <ns-grid #gridWrapper
                   [name]="gridConfigs.gridName"
                   [title]="gridConfigs.gridTitle"
                   [config]="gridConfigs.headerOptions"
                   [columns]="gridConfigs.columns"
                   [data]="data?.emptyPermits || []"
                   [loading]="false"
                   [gridOptions]="gridConfigs.options"
                   (ready)="setGrid($event)">
          </ns-grid>
        </div>
      </div>
      <div class="border p-2 m-2 row" [ngClass]="form.controls.option.value === 'traceCar' ? 'border-primary' : ''">
        <div class="col-md-2 col-sm-4">
          <mat-radio-button class="mt-4" value="traceCar"><strong>Select Empties via Trace car</strong></mat-radio-button>
        </div>
        <div class="col-md-10 col-sm-8">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput formControlName="traceCar" type="text" placeholder="Enter trace car here">
            <mat-error *ngIf="form.controls.traceCar.hasError('pattern')">
              Please provide a valid car
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="border p-2 m-2 row" [ngClass]="form.controls.option.value === 'carEntry' ? 'border-primary' : ''">
        <div class="col-12">
          <mat-radio-button value="carEntry"><strong>Manual Car Entry</strong></mat-radio-button>
        </div>
      </div>
    </mat-radio-group>
  </form>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="close" mat-dialog-close>Back</button>
    <button mat-flat-button aria-label="Back" class="ml-1" color="accent" (click)="emitLoadShipment()"
            [disabled]="(form.controls.option.value === 'permit' && !gridWrapper.ag?.api?.getSelectedRows()?.length) || (form.controls.option.value === 'traceCar' && !form.controls.traceCar.valid)">
      Load Shipment
    </button>
  </div>
</ng-dialog-footer>
